import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { TimeOffService } from '../../../pages/timeoff/time-off.service';

@Component({
  selector: 'app-view-company-holiday-modal',
  templateUrl: './view-company-holiday-modal.component.html',
  styleUrls: ['./view-company-holiday-modal.component.css']
})
export class ViewCompanyHolidayModalComponent implements OnInit {
  @Input() userID : number;
  @Input() msg: string;
  formData: { [key: string]: any };
  yearList: any[];
  modalMsg: string;
  format: string;
  portalSettings: any;
  holidayList: any;

  constructor(private timeOffService:TimeOffService, private portalSettingsService:PortalSettingsService, private ngbActiveModal:NgbActiveModal) {
    this.portalSettings = this.portalSettingsService.getPortalSettings();
   }

  ngOnInit(): void {
    this.formData = {};
    this.yearList = [];
    this.modalMsg = this.msg;
    var current = moment().format("YYYY");
    this.yearList.push({ value: parseInt(current) - 1, name: (parseInt(current) - 1).toString() });
    this.yearList.push({ value: parseInt(current), name: current});
    this.yearList.push({ value: parseInt(current) + 1, name: (parseInt(current) + 1).toString() });
    this.formData.selectedYear = parseInt(current);
    this.format = this.portalSettings.CountryDateCode.ConfigValue == "US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
    this.getHoliday();

  }
  getHoliday(){
    this.timeOffService.getHolidaysByUserKeyID(this.userID,this.formData.selectedYear).then((response:any)=>{
        this.holidayList = response;
        this.holidayList.forEach((val: { HolidayDateString: moment.MomentInput; Day: string; })=> {
            switch (moment(val.HolidayDateString, this.format.toUpperCase()).day()) {
                case 0:
                    val.Day = "Sun"; break;
                case 1:
                    val.Day = "Mon"; break;
                case 2:
                    val.Day = "Tue"; break;
                case 3:
                    val.Day = "Wed"; break;
                case 4:
                    val.Day = "Thr"; break;
                case 5:
                    val.Day = "Fri"; break;
                case 6:
                    val.Day = "Sat"; break;
            }
        });
    });
  }

  closeClicked() {
    this.ngbActiveModal.close('close');
  };
}
